//export const DelphiUserId = 1;
export const DelphiGroupId = 0;
